import * as api from '../api';
import { getIsFetching } from '../reducers/capturesRef';

export const FETCH_CAPTURES = 'intervention.FETCH_CAPTURES';
export const FETCH_CAPTURES_SUCCESS = 'intervention.FETCH_CAPTURES_SUCCESS';

const requestCapturesRef = () => ({
  type: FETCH_CAPTURES,
});

const receiveCapturesRef = refs => ({
  type: FETCH_CAPTURES_SUCCESS,
  refs,
});

export const fetchCapturesRef = () => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestCapturesRef());

  // Request interventions fetching then planning
  return api
    .getCaptureRangeRef()
    .then(response => dispatch(receiveCapturesRef(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/capturesRef.js